export const locale = {
  menu: {
    accommodation: 'Smeštaj',
    locations: 'Destinacije',
    blog: 'Blog',
    contact: 'Kontakt',
  },
  footer: {
    follow_us: 'Zapratite nas',
    subscribe: 'Prijavi se',
  },
  newsletter: {
    title: 'Budi deo naše zajednice',
    description:
      'Prijavi se na newsletter i prati događaje, promocije i aktivnosti koje ne želiš da propustiš.',
    modal_title: 'Prijava na newsletter',
    email_placeholder: 'Vaš email',
    consent_text: 'Saglasan/na sam da primam newsletter emailove.',
    submit: 'Prijavi se',
    sending: 'Slanje...',
    success_localized: 'Uspešno ste se prijavili za newsletter!',
    success_short: 'Uspešno prijavljeni',
    success_fallback: 'Ako ova adresa ispunjava uslove, uspešno je prijavljena.',
    errors: {
      email_required: 'Email je obavezan.',
      consent_required: 'Saglasnost za newsletter je obavezna.',
      unable_to_complete: 'Nismo mogli da završimo prijavu za ovu adresu.',
      validation: 'Proverite unete podatke i pokušajte ponovo.',
      rate_limited: 'Previše pokušaja. Pokušajte ponovo kasnije.',
      generic: 'Došlo je do greške prilikom obrade zahteva. Pokušajte ponovo.',
    },
    unsubscribe: {
      title: 'Odjava sa newslettera',
      loading: 'Obrađujemo vaš zahtev...',
      success_fallback: 'Uspešno ste se odjavili sa newslettera.',
      invalid: 'Link za odjavu nije važeći.',
      error: 'Nismo mogli da obradimo odjavu. Pokušajte ponovo kasnije.',
    },
  },
  validation: {
    email_missing: 'Molimo unesite email',
    newsletter_subscription_success: 'Uspešno ste se prijavili za newsletter!',
    newsletter_subscription_error:
      'Došlo je do greške prilikom slanja zahteva. Molimo Vas pokušajte ponovo.',
  },
  copyright: {
    terms: 'Uslovi korišćenja',
    privacy: 'Politika privatnosti',
  },
  property: {
    description: 'Opis smeštaja',
    images: 'Fotografije',
    location: 'Lokacija',
    submit: 'Pošalji zahtev',
    date: 'Datum...',
    guests: 'Broj osoba',
    total: 'Ukupno',
    full_name: 'Ime i prezime',
    email_address: 'Email adresa',
    phone: 'Telefon (xxx-xxxx-xxx)',
    details: 'Napomene',
  },
  searchBox: {
    title: 'Naziv smeštaja',
    location: 'Lokacija',
    position: 'Pozicija',
    type: 'Tip smeštaja',
    search: 'Pretraga',
  },
  slider: {
    offers: 'Ponuda',
    details: 'Detaljnije',
    deals: 'Celokupna ponuda',
  },
  propertyTypes: {
    all: 'Svi',
    hotels: 'Hoteli',
    river_houses: 'Sojenice',
    apartments: 'Apartmani',
    camps: 'Kampovi',
  },
}
